export default __webpack_public_path__ + "static/media/ff-platform-hover.abac0ea7.svg";